export default function About() {
  return (
    <section id="about" className="py-20 bg-white-clean text-gray-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-5xl font-bold text-blue-600 mb-4">
            👨‍💻 About Me
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          <div className="relative animate-slide-left">
            <div className="w-64 h-64 sm:w-80 sm:h-80 mx-auto bg-gradient-to-br from-cyan-500 to-blue-600 rounded-3xl shadow-2xl flex items-center justify-center animate-float p-3 sm:p-4">
              <img 
                src={require('../Picture/picture.jpg')} 
                alt="Tej - Developer" 
                className="w-56 h-56 sm:w-72 sm:h-72 object-cover rounded-2xl"
              />
            </div>
            <div className="absolute -top-3 -right-3 sm:-top-4 sm:-right-4 w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full opacity-80 animate-bounce"></div>
            <div className="absolute -bottom-3 -left-3 sm:-bottom-4 sm:-left-4 w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r from-pink-400 to-red-500 rounded-full opacity-80 animate-pulse"></div>
          </div>
          
          <div className="space-y-6 animate-slide-right">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 animate-slide-up">
              Passionate Developer & Creator
            </h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed animate-slide-up delay-100">
              I love building creative digital projects with code, combining problem-solving and innovation to bring ideas to life. 
              Sharing my journey, I aim to inspire and create things that truly make an impact.
            </p>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed animate-slide-up delay-200">
              Beyond coding, I love creating content and sharing what I learn with the developer community.
              I'm all about using technology to turn ideas into something real and impactful.
            </p>

            
            <div className="flex flex-wrap gap-2 sm:gap-3 mt-6 sm:mt-8 animate-slide-up delay-500">
              <span className="px-3 sm:px-4 py-1.5 sm:py-2 bg-blue-600 text-white rounded-full text-xs sm:text-sm font-medium hover:scale-110 transition-transform">🧠 Problem Solver</span>
              <span className="px-3 sm:px-4 py-1.5 sm:py-2 bg-emerald-600 text-white rounded-full text-xs sm:text-sm font-medium hover:scale-110 transition-transform">👨‍💻 Digital Creator</span>
              <span className="px-3 sm:px-4 py-1.5 sm:py-2 bg-purple-600 text-white rounded-full text-xs sm:text-sm font-medium hover:scale-110 transition-transform">🤝 Team Player</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
